import { Box, Chip } from "@mui/material";
import React from "react";

import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ChipModal from "./Modal";
import { useBOMDashboardContext } from "../../BOMDashboard.context";
import { secondAxios } from "../../../../../../../../api/axios";

export default function ChipsTableCellComponent({ type, chips }) {
  const [open, setOpen] = React.useState(false);

  const { project, setProject } = useBOMDashboardContext();

  const [entity, setEntity] = React.useState({ srvMaterials: [] });

  const onClick = async (c) => {
    setEntity(c);
    // console.log({ c });

    const existedEntity = project[type + "s"].find((e) => e.id === c.id);
    // console.log({ existedEntity });
    existedEntity
      ? setEntity(existedEntity)
      : await secondAxios
          .get(type + "/" + c.id)
          .then((res) => {
            setEntity(res.data);

            // console.log('call entity by id: ', { data });
            setProject({
              ...project,
              [type + "s"]: [...project[type + "s"], res.data],
            });
          })
          .catch((e) => {
            console.log(e);
          });

    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <Box>
      {chips?.map((c, i) => {
        return c?.id ? (
          <Box key={i} sx={{ p: 0.2 }}>
            <Chip
              icon={<InsertDriveFileIcon />}
              label={
                c[type + "Number"] + (c.rev ? " Rev-" + c.rev : "") //+
                // (c[type + "Date"] ? " - " + c[type + "Date"] : "")
              }
              //   component="a"
              //   href="#basic-chip"
              //   clickable
              onClick={() => onClick(c)}
              variant="outlined"
            />
            <ChipModal
              type={type}
              entity={entity}
              open={open}
              handleClose={handleClose}
            />
          </Box>
        ) : (
          ""
        );
      })}{" "}
    </Box>
  );
}

// <Chip icon={<FaceIcon />} label="With Icon" />
// <Chip icon={<FaceIcon />} label="With Icon" variant="outlined" />
